if (typeof FacetSortBy !== "function") {
    class FacetSortBy extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.querySelectorAll('input[type="radio"]').forEach(radio => {
                radio.addEventListener('click', (event) => {
                    this.handleChange(event);
                });
            });

            const close = this.querySelector('[data-js-sort-close]');

            if (close) {
                close.addEventListener('click', () => {
                    this.handleClose();
                });
            }
        }

        handleChange(event) {
            const selectElement = document.getElementById(`${this.id}-SortBy`);

            if (selectElement) {
                selectElement.value = event.target.value;
                selectElement.dispatchEvent(new Event('change', { bubbles: true }));

                const facetForm = selectElement.closest('form');
                if (facetForm) {
                    this.debouncedOnInput = debounce(() => {
                        facetForm.dispatchEvent(new Event('input', { bubbles: true }));
                    }, 500);
                    this.debouncedOnInput(event);
                }
            }
        }

        handleClose() {
            const details = this.querySelector('details');

            details.removeAttribute('open');
        }
    }

    if (typeof customElements.get("facet-sort-by") == "undefined") {
        customElements.define('facet-sort-by', FacetSortBy);
    }
}
